import script from "./ShopProductGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopProductGallery.vue?vue&type=script&setup=true&lang=js"

import "./ShopProductGallery.vue?vue&type=style&index=0&id=aa25b5ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa25b5ec"]])

export default __exports__